let lenis = null;

export const setLenis = (instance) => {
  lenis = instance;
};

export const getLenis = () => lenis;

export const scrollToSection = (id) => {
  const instance = getLenis();
  if (instance) {
    instance.scrollTo(`#${id}`, { duration: 1.4 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
